import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from "../../../helpers/intlMessage";
import { Badge } from '@material-ui/core';
import Filtro from '../Faturamento/Filtro/index';
import { useDispatch } from 'react-redux';
import * as commonActions from '../../../app/common/common.action';
import { httpRequest } from '@util/api-common.util';
import Grid from './Grid';
import { returnParamiters, returnStatus } from '../relatorio.utils';
import WebapiCommon from '@util/webapi.common';
import ModalFaturamentoContainer from '../../../../src/pages/main/listagem/modais/faturamento/modal.faturamento.container';
import { useIntl } from 'react-intl';

function Faturamento({
  onclickLine,
  showBtnImprimir,
}) {
  const lista = useSelector(state => state.solicitacao.listaSolicitacoes);
  const laudoFaturado = useSelector(state => state.commonReducer.laudoFaturado);
  const modalFaturamento = useSelector(state => state.commonReducer.modalFaturamento);
  const [filtro, setFiltro] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [listaLaudos, setListaLaudos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const offset = 20;
  const dispatch = useDispatch();
  const first = useRef();
  const firstfaturado = useRef();
  const intl = useIntl();

  useEffect(() => {
		if (firstfaturado.current) {
			!modalFaturamento && laudoFaturado && getData();
		}
		firstfaturado.current = true;
	}, [modalFaturamento, laudoFaturado]);

  useEffect(() => {
    if (first.current) {
      getData();
    }
    first.current = true;
  }, [pagina])

  function getData() {
    const { medico, periodoInicial, periodoFinal, tipo, value } = filtro;

    let params = returnParamiters({
      'dataInicio': periodoInicial,
      'dataFim': periodoFinal,
      'tipoFiltro': tipo,
      'tipoFiltroValue': value,
      'pagina': pagina,
      'quantidadePaginacao': offset
    });

    if (tipo.indexOf('dt') >= 0) {
      const result = CommonFunctions.validaData(periodoInicial, periodoFinal, intl, commonActions);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }
    }

    if (medico) params.medicoId = medico;
    dispatch(commonActions.showFadeCarregando(true));
    httpRequest('Faturamento',
      'POST', {
      'dataInicio': periodoInicial,
      'dataFim': periodoFinal,
      'tipoFiltro': tipo,
      'tipoFiltroValue': value,
      'pagina': pagina,
      'quantidadePaginacao': offset
    }).then((response) => {
      setTotal(response && response.totalItems);
      setListaLaudos(formatItens(response && response.data));
      dispatch(commonActions.showFadeCarregando(false));
    }).catch((error) => {
      console.error(error);
      dispatch(commonActions.showFadeCarregando(false));
    });
  }

  const filtrar = async filtro => {
    getData();
  };

  useEffect(() => {
    commonActions.mudarStatusModalFaturamento(false)
    const periodo = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = periodo;

    setFiltro({ periodoInicial, periodoFinal });
    loadItensFiltro();
    setTotal([{ label: <IntlMessage id="dashboards.reports.all" />, value: null }, ...lista]);
  }, [lista]);

  const loadItensFiltro = async () => {
    try {
      const response = await WebapiCommon.getTiposExame();
      setTiposExame(response);
    } catch (error) { }
  };

  const formatItens = (l) => {
    if (l.length === 0) {
      commonActions.showAlerta(
        'error',
        <IntlMessage id="dashboards.examDetail.attachmentFailure" />,
        2000
      );
    } else {
      return l.map(item => {
        const { backgroundColor, color, label } = returnStatus(item);
        return {
          ...item,
          statusFormatted: (
            <Badge style={{ fontSize: '12px', backgroundColor, color }}>
              {label}
            </Badge>
          )
        };
      });
    }
  };

  return (
    <React.Fragment>
      <ModalFaturamentoContainer />
      <Filtro
        filtro={filtro}
        setFiltro={setFiltro}
        filtrar={filtrar}
        showBtnImprimir={showBtnImprimir}
      ></Filtro>
      {listaLaudos && listaLaudos.length > 0 && (
        <Grid
          setModalOpen={setModalOpen}
          lista={listaLaudos}
          totalItens={total}
          pagina={pagina}
          totalItensPage={20}
          setPagina={setPagina}
          onclickLine={onclickLine}
          commmonActions={commonActions}
        />
      )}
      {listaLaudos && listaLaudos.length === 0 &&
        <div className='icone-semdados'>
          <i className='inicial-icons mv-basico-faturamento'></i>
        </div>}
    </React.Fragment>
  );
}

export default Faturamento;


// WEBPACK FOOTER //
// ./src/pages/relatorio/Faturamento/index.js